import { render, staticRenderFns } from "./GeneratePrivateKeyDexIdModal.vue?vue&type=template&id=bba553a0&scoped=true"
import script from "./GeneratePrivateKeyDexIdModal.vue?vue&type=script&lang=ts"
export * from "./GeneratePrivateKeyDexIdModal.vue?vue&type=script&lang=ts"
import style0 from "./GeneratePrivateKeyDexIdModal.vue?vue&type=style&index=0&id=bba553a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba553a0",
  null
  
)

export default component.exports